import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import useAuth from 'hooks/useAuth';
import Loader from 'components/Loader';

// ==============================|| AUTH GUARD ||============================== //

interface Props {
  children: React.ReactElement | null;
}

export default function AuthGuard({ children }: Props) {
  const { isLoggedIn, isInitialized } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (isInitialized && !isLoggedIn) {
      navigate('/login', { state: { from: location.pathname }, replace: true });
    }
  }, [isLoggedIn, isInitialized, navigate, location]);

  if (!isInitialized) return <Loader />;
  if (!isLoggedIn) return null;

  return children;
}
